<template>
  <div class="lgpd-registros-page" data-testid="lgpd-registros-page">
    <page-header :title="t('Registros de aceite de termos LGPD')" />

    <Tabs :value="activeTab" @update:value="handleTabChange">
      <TabList>
        <Tab
          value="termos"
          data-testid="lgpd-registros-tab-termos"
        >
          {{ t('Termos cadastrados') }}
        </Tab>
        <Tab
          value="aceites"
          data-testid="lgpd-registros-tab-aceites"
        >
          {{ t('Aceites registrados') }}
        </Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="termos">
          <lgpd-termos-table ref="termosTableRef" />
        </TabPanel>
        <TabPanel value="aceites">
          <lgpd-aceites-table ref="aceitesTableRef" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { log } from '../../utils/DebugLogger';
import PageHeader from '../../ui/PageHeader.vue';
import LgpdTermosTable from './LgpdTermosTable.vue';
import LgpdAceitesTable from './LgpdAceitesTable.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const activeTab = ref<string>('termos');
const termosTableRef = ref<InstanceType<typeof LgpdTermosTable> | null>(null);
const aceitesTableRef = ref<InstanceType<typeof LgpdAceitesTable> | null>(null);

const tabFromHash = (hash: string | undefined): string => {
  return (hash?.toLowerCase() === '#aceites') ? 'aceites' : 'termos';
};

const handleTabChange = (value: string | number): void => {
  log('LgpdRegistrosPage', 'handleTabChange', 'Tab changed to', value);
  activeTab.value = String(value);
  // Update URL hash to persist tab state
  const hash = value === 'termos' ? '#termos' : '#aceites';
  router.replace({ hash }).catch(() => {});
};

onMounted(() => {
  activeTab.value = tabFromHash(route.hash);
});

// Vue Router reuses the component instance when only the hash changes,
// so onMounted does not re-fire. Watch the hash so deep-linking via
// `/lgpd-registros#aceites` activates the correct tab even when arriving
// from `/lgpd-registros` (no hash).
watch(() => route.hash, (newHash) => {
  activeTab.value = tabFromHash(newHash);
});
</script>

<style scoped>
.lgpd-registros-page {
  width: 100%;
}
</style>
